import CircularSlider from "@fseehawer/react-circular-slider";
import { MAX_SCORE } from "config";
import { MIN_SCORE } from "config";
import { DEFAULT_SCORE } from "config";
import { useCallback } from "react";
import getStatus from "utils/getStatus";
import patternMatching from "utils/patternMatching";
import { ReactComponent as WhiteDot } from "assets/white_dot.svg";
import { colors } from "styles";

const ScoreWheel = ({
  score,
  onChange,
  disabled,
  maxValue,
  minValue,
  label,
  $size,
  $trackColor,
}) => {
  const maxRange = maxValue || MAX_SCORE;
  const minRange = minValue || MIN_SCORE;
  const status = getStatus(score);
  const scoreRange = useCallback(
    () =>
      Array((maxRange - minRange) / 10 + 1)
        .fill(10)
        .map((v, i) => v * i + minRange),
    [minRange, maxRange]
  );

  return (
    <>
      <CircularSlider
        data={scoreRange()}
        dataIndex={scoreRange().findIndex((value) => value === score)}
        width={patternMatching([
          ["small", 80],
          ["medium", 120],
          ["large", 280],
        ])($size)}
        knobPosition="bottom"
        knobColor={status.colors[1]}
        knobSize={patternMatching([
          ["small", 20],
          ["medium", 25],
          ["large", 65],
        ])($size)}
        hideKnob={disabled}
        progressColorFrom={status.colors[0]}
        progressColorTo={status.colors[1]}
        progressSize={patternMatching([
          ["small", 5],
          ["medium", 7],
          ["large", 20],
        ])($size)}
        trackColor={$trackColor}
        trackSize={patternMatching([
          ["small", 7],
          ["medium", 7],
          ["large", 20],
        ])($size)}
        label={label || status.label}
        labelBottom
        valueColo
        labelColor={status.colors[1]}
        labelFontSize={patternMatching([
          ["small", "0.6rem"],
          ["medium", "0.6rem"],
          ["large", "2rem"],
        ])($size)}
        valueFontSize={patternMatching([
          ["small", "2.2rem"],
          ["medium", "3.2rem"],
          ["large", "8rem"],
        ])($size)}
        onChange={(value) => {
          onChange?.(value);
        }}
        knobDraggable={!disabled}
      >
        <WhiteDot />
      </CircularSlider>
    </>
  );
};

ScoreWheel.defaultProps = {
  score: DEFAULT_SCORE,
  $size: "large",
  $trackColor: colors.white,
};

export default ScoreWheel;
